export class Beta {
  desktopApp: boolean;
  zoom: boolean;

  constructor(beta?: Beta) {
    if (undefined === beta) {
      this.getDefaultValues();
    } else {
      this.desktopApp = beta.desktopApp;
      this.zoom = beta.zoom;
    }
  }

  getDefaultValues() {
    this.desktopApp = false;
    this.zoom = false;
  }
}
